import { logError } from '@ecomm/error-handling'
import { useCallback } from 'react'
import { useNavigate as useReactRouterNavigate } from 'react-router'
import { gatsbyNavigate } from './lib/gatsbyHelpers'
import type { NavigationState } from './lib/gatsbyHelpers'

/**
 * Type for the options argument to navigate.
 */
export type NavigateOptions = {
  readonly state?: NavigationState
  readonly replace?: boolean
}

/**
 * Type for the navigate function used throughout the app.
 */
type NavigateFunction = (to: string, options?: NavigateOptions) => void

/**
 * Returns a navigate function that works with Remix or Gatsby.
 */
export const useNavigate = (): NavigateFunction => {
  // Remix's useNavigate hook throws an error if it's not used inside a Router,
  // so we have to wrap it in a try/catch block
  try {
    // TODO: ECP-14840 react-compiler/react-compiler
    const navigate = useReactRouterNavigate()
    return useCallback(
      (to: string, options?: NavigateOptions) => {
        navigate(to, options)?.catch(logError)
      },
      [navigate]
    )
  } catch {
    return useCallback((to: string, options?: NavigateOptions) => {
      gatsbyNavigate(to, options)
    }, [])
  }
}
